import { Link } from "react-router-dom";
import ScrollReveal from "@/components/base/ScrollReveal";

export default function ServicesSection() {
  const services = [
    {
      id: "policy",
      title: "保單門神",
      tag: "家庭 / 個人",
      content:
        "健診・整合・補強，讓每 1 元的保費效益最大化；舊保單不符時代脈絡導致保障不足，由我來調整。",
      cta: "了解保單門神",
      icon: "ri-shield-check-line",
    },
    {
      id: "asset",
      title: "財產門神",
      tag: "資產配置 / 風險控管",
      content:
        "從財務槓桿到資產配置，打造現金流、掌控投資風險與波動，讓財富與資產持續增加。",
      cta: "了解財產門神",
      icon: "ri-bar-chart-box-line",
    },
    {
      id: "life",
      title: "人生門神",
      tag: "教育金 / 退休 / 傳承",
      content:
        "以人生階段為主軸，成家、生子、換屋、創業、退休、傳承，讓每一個重要選擇都有底氣。",
      cta: "了解人生門神",
      icon: "ri-heart-pulse-line",
    },
    {
      id: "enterprise",
      title: "企業門神",
      tag: "企業主 / 組織",
      content:
        "專業守護企業主與員工福利保障，打造未來傳承架構，用制度讓企業長久運行。",
      cta: "了解企業門神",
      icon: "ri-building-line",
    },
  ];

  return (
    <section className="py-20 md:py-28 bg-brand-black relative">
      {/* Subtle gold glow */}
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full opacity-5"
        style={{
          background: "radial-gradient(circle, #D4AF37 0%, transparent 70%)",
        }}
      />

      <div className="container-main relative z-10">
        {/* Section Title */}
        <ScrollReveal className="text-center mb-14 md:mb-16">
          <h2 className="text-white font-display font-bold text-[1.5rem] md:text-[2.125rem] leading-[1.4] mb-3">
            四大價值主張
          </h2>
          <p className="text-brand-text-secondary text-[1.0625rem] md:text-[1.1875rem] leading-[1.75] max-w-[560px] mx-auto">
            以「守護」為核心，把複雜變簡單，透過策略與執行方案，形成可長可久的保護力。
          </p>
          <div className="w-[60px] h-[2px] bg-brand-gold mx-auto mt-4" />
        </ScrollReveal>

        {/* Service Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {services.map((service, index) => (
            <ScrollReveal key={service.id} delay={index * 100}>
              <div
                className="group bg-brand-card border border-brand-border rounded-xl p-6 md:p-7 transition-all duration-300 hover:-translate-y-2 hover:border-brand-gold/50 flex flex-col h-full"
              >
                {/* Icon */}
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-xl bg-brand-gold/10 mb-5">
                  <span className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center text-brand-gold text-xl md:text-2xl">
                    <i className={service.icon} />
                  </span>
                </div>

                {/* Title */}
                <h3 className="text-white font-semibold text-[1.25rem] md:text-[1.625rem] leading-[1.5] mb-1">
                  {service.title}
                </h3>
                <span className="inline-block self-start border border-brand-border rounded-full px-3 py-1 text-brand-gold text-[0.875rem] font-medium mb-4">
                  {service.tag}
                </span>

                {/* Content */}
                <p className="text-brand-text-secondary text-[1.0625rem] leading-[1.75] mb-5 flex-1">
                  {service.content}
                </p>

                {/* CTA */}
                <Link
                  to={`/services/${service.id}`}
                  className="inline-flex items-center gap-2 text-brand-gold font-medium text-[1rem] group-hover:gap-3 transition-all"
                >
                  {service.cta}
                  <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
